import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BaseComponent from './BaseComponent';
import Style from './Maze.cssmodule.less';
import { clickButton, updateItemIndex } from '../../actions/Modal';
import {
    pagerActionTypes,
    compStatusTypes,
    ModalTypes,
    ContentTypes,
} from '@/Constants';
import Button from '../CommonSet/Button';
import Title from '../CommonSet/Title';
import Pager from '../CommonSet/Pager';

class Maze extends BaseComponent {
    constructor(props) {
        super(props);
        this.setMazeTheme(props.theme);
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handlePagerClick = this.handlePagerClick.bind(this);
        this.state = this.getPagerStatus(props);
    }

    setMazeTheme(theme) {
        const themeStyle = this.getTheme(theme, ModalTypes.MAZE);
        this.Style = themeStyle || Style;
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.itemIndex !== this.props.itemIndex ||
            nextProps.maxIndex !== this.props.maxIndex
        ) {
            this.setState(this.getPagerStatus(nextProps));
        }
    }

    getPagerStatus(props) {
        const pagerStatus = {};
        if (props.itemIndex <= 0) {
            pagerStatus.prevStatus = compStatusTypes.HIDDEN;
            if (props.itemIndex !== props.maxIndex - 1) {
                pagerStatus.nextStatus = compStatusTypes.ENABLED;
            } else {
                pagerStatus.nextStatus = compStatusTypes.HIDDEN;
            }
        } else if (props.itemIndex >= props.maxIndex - 1) {
            pagerStatus.prevStatus = compStatusTypes.ENABLED;
            pagerStatus.nextStatus = compStatusTypes.HIDDEN;
        } else {
            pagerStatus.prevStatus = compStatusTypes.ENABLED;
            pagerStatus.nextStatus = compStatusTypes.ENABLED;
        }

        return pagerStatus;
    }

    handlePagerClick(status) {
        const { updateItemIndex } = this.props.actions;
        let itemIndex = this.props.itemIndex;
        if (status === pagerActionTypes.NEXT) {
            itemIndex += 1;
        } else if (status === pagerActionTypes.PREV) {
            itemIndex -= 1;
        }
        updateItemIndex(itemIndex);
    }

    handleButtonClick(event) {
        const { clickButton } = this.props.actions;
        clickButton({
            event,
        });
    }

    makeContentView(viewItem, index) {
        const {
            type = ContentTypes.TEXT,
            content = '',
            character = {},
        } = viewItem;
        let contentView = null;
        switch (type) {
            case ContentTypes.TEXT: {
                contentView = (
                    <div
                        key={`content${type}${index}`}
                        className={this.Style[type]}
                    >
                        <div
                            className={this.Style.htmlContent}
                            dangerouslySetInnerHTML={{
                                __html: content,
                            }}
                        />
                    </div>
                );
                break;
            }
            case ContentTypes.CHARACTER_TEXT: {
                const { image = '' } = character;
                contentView = (
                    <div
                        key={`content${type}${index}`}
                        className={this.Style[type]}
                    >
                        <img
                            src={image}
                            className={this.Style.characterImage}
                        />
                        <div
                            className={this.Style.htmlContent}
                            dangerouslySetInnerHTML={{
                                __html: content,
                            }}
                        />
                    </div>
                );
                break;
            }
            case ContentTypes.IMAGE: {
                contentView = (
                    <div
                        key={`content${type}${index}`}
                        className={this.Style[type]}
                    >
                        <img src={content} className={this.Style.image} />
                    </div>
                );
                break;
            }
            case ContentTypes.BLOCK: {
                contentView = (
                    <div
                        key={`content${type}${index}`}
                        className={this.Style[type]}
                        ref={(blockWrapper) => {
                            if (blockWrapper) {
                                blockWrapper.innerHTML = '';
                                const blockRenderView = new Entry.RenderView(
                                    blockWrapper,
                                    'LEFT_MOST'
                                );
                                blockRenderView.changeCode(
                                    new Entry.Code(content),
                                    true
                                );
                            }
                        }}
                    />
                );
                break;
            }
        }
        return contentView;
    }

    makeContent() {
        const { item = {} } = this.props;
        const { content = {} } = item;
        const { layout, title = '', contents = [] } = content;
        const contentView = [];
        contents.forEach((viewItem, i) => {
            contentView.push(this.makeContentView(viewItem, i));
        });
        return (
            <div className={this.Style[layout]}>
                <div className={this.Style.contentTitle}>{title}</div>
                {contentView}
            </div>
        );
    }

    render() {
        const { item = {} } = this.props;
        const { className, title = '' } = item;

        return (
            <div className={`${this.Style.Maze} ${this.Style[className]}`}>
                <Title
                    className={this.Style.title}
                    isClose
                    onClose={() => this.handleButtonClick('close')}
                >
                    {title}
                </Title>
                <div className={this.Style.contentView}>
                    <Pager
                        onPagerClick={this.handlePagerClick}
                        prevStatus={this.state.prevStatus}
                        nextStatus={this.state.nextStatus}
                    >
                        <div className={this.Style.content}>
                            {this.makeContent()}
                        </div>
                    </Pager>
                </div>
            </div>
        );
    }
}

Maze.displayName = 'Maze';
Maze.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton, updateItemIndex };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(
    undefined,
    mapDispatchToProps
)(Maze);



// WEBPACK FOOTER //
// ./components/ModalSet/Maze.js